import VeryGoodActive from '../../Assets/images/interview/feedbackEmojis/VeryGoodActive.svg';
import VeryGood from '../../Assets/images/interview/feedbackEmojis/VeryGood.svg';
import Good from '../../Assets/images/interview/feedbackEmojis/Good.svg';
import GoodActive from '../../Assets/images/interview/feedbackEmojis/GoodActive.svg';
import Fair from '../../Assets/images/interview/feedbackEmojis/Fair.svg';
import FairActive from '../../Assets/images/interview/feedbackEmojis/FairActive.svg';
import Bad from '../../Assets/images/interview/feedbackEmojis/Bad.svg';
import BadActive from '../../Assets/images/interview/feedbackEmojis/BadActive.svg';
import Excellent from '../../Assets/images/interview/feedbackEmojis/Excellent.svg';
import ExcellentActive from '../../Assets/images/interview/feedbackEmojis/ExcellentActive.svg';
import { useEffect, useState } from 'react';
import { Tooltip, Input, Radio, Checkbox, message, Spin } from 'antd';
import 'Styles/VideoInterviewComponent.scss';
import { useForm, Controller } from 'react-hook-form';
import { useParams, useSearchParams } from 'react-router-dom';
import {
  useGetCandidateFeedbackQuestions,
  useGetCandidateFeedbackQuestionsView,
  useSetFeedBackAnswer,
} from 'ServiceHooks/interviewHooks';
import { LoadingOutlined } from '@ant-design/icons';
import Button from 'Components/CommonComponents/Button/Button';
import CompletedBotImg from '../../Assets/images/CompletedBot.svg';
import ConfettiImg from '../../Assets/images/GroupConfetti.svg';
import { usePersistedStore } from 'Store/persistedStore';

const { TextArea } = Input;

const emotions = [
  {
    icon: Bad,
    icon_active: BadActive,
    label: 'Bad',
    value: 'BAD',
  },
  {
    icon: Fair,
    icon_active: FairActive,
    label: 'Fair',
    value: 'FAIR',
  },
  {
    icon: Good,
    icon_active: GoodActive,
    label: 'Good',
    value: 'GOOD',
  },
  {
    icon: VeryGood,
    icon_active: VeryGoodActive,
    label: 'Very Good',
    value: 'VERY_GOOD',
  },
  {
    icon: Excellent,
    icon_active: ExcellentActive,
    label: 'Excellent',
    value: 'EXCELLENT',
  },
];

const CandidateFeedBack = () => {
  const { interview_id } = useParams();
  const [searchParams] = useSearchParams();
  const isView = searchParams.get('is_view');
  const interview_id_decoded = atob(interview_id);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();
  const [isSubmitted, setSubmitted] = useState(false);
  const [customError, setCustomError] = useState([]);
  const [showError, setShowError] = useState(false);
  const [interviewData, setInterviewData] = useState(null);
  const [hoveredIndexForm, setHoveredIndexForm] = useState(null);

  const { interviewDetails } = usePersistedStore();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, dirtyFields },
    setValue,
    setError,
    getValues,
    watch,
    clearErrors,
  } = useForm({
    mode: 'all',
  });

  const { data, isFetching, isLoading, refetch, error } =
    useGetCandidateFeedbackQuestions({
      interview_id: interview_id_decoded,
      enabled: !Boolean(isView),
    });

  const {
    data: viewData,
    isFetching: isFetchingViewData,
    isLoading: isLoadingViewData,
  } = useGetCandidateFeedbackQuestionsView({
    interview_id: interview_id_decoded,
    enabled: Boolean(isView),
  });

  // const data = []
  // const isFetching = false
  // const isLoading = false
  // const error = {}

  const questions = isView
    ? viewData?.data?.questions
    : data?.data?.questions;

  const feedbackData = isView ? viewData?.data : data?.data;

  console.log(isView, 'isViewisView');
  const { mutateAsync: submitAnswer } = useSetFeedBackAnswer({
    onSuccess: async (data) => {
      setInterviewData(data);
      await messageApi.open({
        type: 'success',
        content: 'You’ve successfully submitted',
      });
      setSubmitted(true);
    },
  });

  const getCustomValidation = (answers) => {
    console.log(questions, 'questionsquestions', customError);
    const mandatoryIds = questions
      .filter((item) => item.is_mandatory)
      .map((item) => item.id);
    const missingIds = mandatoryIds.filter(
      (id) => !Object.keys(answers).includes(`question-${id}`),
    );
    setCustomError(missingIds);
    if (missingIds?.length || !watch('emotion')) {
      if (!watch('emotion')) {
        setShowError(true);
      }
      return false;
    } else return true;
  };

  const onSubmit = async (data) => {
    try {
      const { comments, emotion, ...questions } = data;
      const validate = getCustomValidation(questions);
      console.log(validate,"validatevalidate");
      if (validate) {
        const answers = Object.values(questions);
        const body = {
          comments,
          emotion,
          answers,
        };
        console.log(body, 'bodybodybody');
        await submitAnswer({
          interview_id: interview_id_decoded,
          body,
        });
      }
    } catch (error) {
      console.log(error?.response?.status, 'errorerrorerror');
      if (error?.response?.status === 404) {
        await messageApi.open({
          type: 'error',
          content: 'Link Expired',
        });
      }
    }
  };
  console.log(customError, 'customErrorcustomError');
  const getAnswerIds = (options) => {
    return options
      .filter((option) => option.is_answer)
      .map((option) => option.id);
  };

  useEffect(() => {
    if (viewData) {
      console.log(viewData, 'viewDataviewData');
      if (viewData?.data?.emotion) {
        setValue('emotion', viewData?.data?.emotion);
      }
      if (viewData?.data?.comments) {
        setValue('comments', viewData?.data?.comments);
      }

      questions?.map((qstn) => {
        if (
          qstn?.answer_type === 'SHORT_ANS' ||
          qstn?.answer_type === 'LONG_ANS'
        ) {
          setValue(`question-${qstn?.id}`, {
            question: qstn?.id,
            answer: qstn?.answer,
            multi_options_answers: [],
            yes_or_no: false,
          });
        }

        if (
          qstn?.answer_type === 'OPTIONS' ||
          qstn?.answer_type === 'MULTI_CHOICE'
        ) {
          const checkedValues = getAnswerIds(qstn?.multi_options_answers);
          setValue(`question-${qstn?.id}`, {
            question: qstn?.id,
            answer: '',
            multi_options_answers: checkedValues,
            yes_or_no: false,
          });
        }

        if (qstn?.answer_type === 'BOOL') {
          setValue(`question-${qstn?.id}`, {
            question: qstn?.id,
            answer: '',
            multi_options_answers: [],
            yes_or_no: qstn?.yes_or_no,
          });
        }
        if (qstn?.answer_type === 'EMOJI') {
          setValue(`question-${qstn?.id}`, {
            question: qstn?.id,
            emoji: qstn?.emoji,
            answer: '',
            multi_options_answers: [],
            yes_or_no: false,
          });
        }
      });
    }
  }, [viewData]);
  console.log(interviewDetails,"interviewDetails");
  const jobTitle = interviewDetails?.data?.title ?? '';
  const totalTime = interviewDetails?.data?.total_duration_str ?? '';
  const jobId = interviewDetails?.data?.job_reference_number ?? '';
  const timeTaken = interviewDetails?.data?.total_time_taken_by_candidate ?? '';

  return (
    <>
      {contextHolder}
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex ms:items-center items-start justify-center h-screen bg-[#F7F7F7] flex-col ms:p-0 px-6"
      >
        {error?.response?.status === 404 || isSubmitted ? (
          <div>
            {isSubmitted ? (
              <div className="h-screen w-screen relative bg-neutral-100 flex flex-col items-center justify-center">
                <img
                  src={ConfettiImg}
                  style={{
                    transform: 'rotateY(180deg)',
                  }}
                  className="absolute bottom-0 left-0 z-0"
                />
                <div className="xs:w-11/12 tab:w-3/4 xs:h-full tab:h-5/6 grid grid-cols-6 grid-rows-6 gap-4">
                  <div className="xs:row-start-1 tab:row-start-2 row-span-3 col-start-1 xs:col-span-full tab:col-span-3 justify-items-center space-y-6">
                    <img
                      src={CompletedBotImg}
                      className="xs:max-tab:w-1/2 xs:max-tab:pt-4"
                    />
                    <div className="capitalize text-3xl text-center xs:w-full tab:w-3/5 font-semibold">
                      Interview successfully submitted
                    </div>
                    <div className="text-center text-zinc-800 text-lg font-normal xs:w-full tab:w-3/5">
                      Our team will contact you for further hiring
                      procedures if you are shortlisted.
                    </div>
                    <Button
                      isCancel
                      className="px-9 rounded-full xs:hidden tab:block"
                    >
                      Thank you for attending!
                    </Button>
                  </div>

                  <div className="xs:row-start-4 tab:row-start-3 row-span-2 xs:col-start-1 tab:col-start-4 xs:col-span-full tab:col-span-2 bg-white rounded-lg justify-items-center content-center space-y-4 z-10">
                    <div className="text-black text-2xl font-normal pb-2 capitalize">
                      {jobTitle}
                    </div>
                    <div className="text-neutral-800 text-lg font-normal">
                      Job Code: {jobId}
                    </div>
                    <div className="text-neutral-800 text-lg font-normal capitalize">
                      submission time: {timeTaken}
                    </div>
                    <div className="text-neutral-800 text-lg font-normal">
                      Duration: {totalTime}
                    </div>
                  </div>

                  <div className="row-start-6 col-span-full text-black text-sm font-light capitalize justify-self-center xs:self-start tab:self-end">
                    © 2024 YVI | All Rights Reserved
                  </div>
                  <div className="row-start-6 col-span-full self-end mb-2 justify-self-center xs:block tab:hidden z-20">
                    <Button
                      isCancel
                      className="px-9 rounded-full xs:block tab:hidden bg-white"
                    >
                      Thank you for attending!
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="bg-white p-40">
                <p className="text-lg font-medium">Link Expired</p>
              </div>
            )}
          </div>
        ) : (!isView && (isFetching || isLoading)) ||
          (isView && (isFetchingViewData || isLoadingViewData)) ? (
          <div className="bg-white ms:w-4/6 w-full ms:h-4/6 h-full ms:flex block items-center justify-center">
            <Spin
              indicator={
                <LoadingOutlined
                  style={{
                    fontSize: 48,
                  }}
                  spin
                />
              }
            />
          </div>
        ) : (
          <>
            {/* overflow-y-auto add if dynamic question*/}
            <div className="bg-white ms:w-4/6 w-full ms:h-[75%] h-full ms:flex block overflow-y-auto ms:overflow-y-hidden">
              <div className="ms:w-1/2 w-full rounded-md p-11">
                <p className="text-[#494949] font-medium text-lg">
                  Feedback
                </p>
                {/* overflow-y-auto add if dynamic question */}
                <div className="w-full h-full flex justify-center items-center">
                  <div className="flex flex-col gap-9  customScrollBar overflow-y-auto ms:overflow-y-hidden">
                    {questions?.map((qstn) => (
                      <div>
                        <p className="text-[#000] font-medium text-sm mb-2">
                          {qstn?.question}
                        </p>
                        {qstn?.answer_type === 'SHORT_ANS' ? (
                          <>
                            <Input
                              {...register(`question-${qstn?.id}`, {
                                required: qstn?.is_mandatory
                                  ? 'This field is required'
                                  : false,
                              })}
                              placeholder="Add a comment..."
                              className="placeholder:text-[#8F8F8F] placeholder:text-xs border border-[#AFD6D4] bg-[#FBFBFB] rounded-md"
                              name={qstn?.id}
                              key={qstn?.id}
                              onChange={(e) =>
                                setValue(`question-${qstn?.id}`, {
                                  question: qstn?.id,
                                  answer: e.target.value,
                                  multi_options_answers: [],
                                  yes_or_no: false,
                                })
                              }
                              value={watch(`question-${qstn?.id}`)?.answer}
                              disabled={Boolean(isView)}
                            />
                            {errors[`question-${qstn?.id}`] && (
                              <p className="text-red-500 text-xs mt-1">
                                {errors[`question-${qstn?.id}`]?.message}
                              </p>
                            )}
                          </>
                        ) : qstn?.answer_type === 'LONG_ANS' ? (
                          <>
                            <TextArea
                              {...register(`question-${qstn?.id}`, {
                                required: qstn?.is_mandatory
                                  ? 'This field is required'
                                  : false,
                              })}
                              rows={2}
                              placeholder="Add a comment.."
                              className="placeholder:text-[#8F8F8F] placeholder:text-xs border border-[#AFD6D4] bg-[#FBFBFB] rounded-md"
                              name={qstn?.id}
                              key={qstn?.id}
                              onChange={(e) =>
                                setValue(`question-${qstn?.id}`, {
                                  question: qstn?.id,
                                  answer: e.target.value,
                                  multi_options_answers: [],
                                  yes_or_no: false,
                                })
                              }
                              value={watch(`question-${qstn?.id}`)?.answer}
                              disabled={Boolean(isView)}
                            />
                            {errors[`question-${qstn?.id}`] && (
                              <p className="text-red-500 text-xs mt-1">
                                {errors[`question-${qstn?.id}`]?.message}
                              </p>
                            )}
                          </>
                        ) : qstn?.answer_type === 'OPTIONS' ? (
                          <div>
                            <Radio.Group
                              // {...register(`question-${qstn?.id}`, {
                              //   required: qstn?.is_mandatory
                              //     ? 'Please select an option'
                              //     : false,
                              // })}
                              onChange={(e) => {
                                setValue(`question-${qstn?.id}`, {
                                  question: qstn?.id,
                                  answer: '',
                                  multi_options_answers: [e.target.value],
                                  yes_or_no: false,
                                });
                                if (customError?.includes(qstn?.id)) {
                                  const updatedArray = customError.filter(
                                    (id) => id !== qstn?.id,
                                  );
                                  setCustomError(updatedArray);
                                }
                              }}
                              label=""
                              disabled={Boolean(isView)}
                              className="flex flex-wrap  xs:flex-col md:flex-row"
                              value={
                                watch(`question-${qstn?.id}`)
                                  ?.multi_options_answers?.[0]
                              }
                            >
                              {qstn?.multi_options_answers?.map(
                                (item, i) => (
                                  <div
                                    key={`options-${i}`}
                                    className="feedback_radio"
                                  >
                                    <Radio
                                      className="feedback_radio"
                                      key={i}
                                      value={item.id}
                                    >
                                      {item.option}
                                    </Radio>
                                  </div>
                                ),
                              )}
                            </Radio.Group>
                            {customError?.includes(qstn?.id) && (
                              <p className="text-red-500 text-xs mt-1">
                                This field is required
                              </p>
                            )}
                          </div>
                        ) : qstn?.answer_type === 'MULTI_CHOICE' ? (
                          <div>
                            <Checkbox.Group
                              // {...register(`question-${qstn?.id}`, {
                              //   required: qstn?.is_mandatory
                              //     ? 'Please select at least one option'
                              //     : false,
                              // })}
                              onChange={(checkedValues) => {
                                setValue(`question-${qstn?.id}`, {
                                  question: qstn?.id,
                                  answer: '',
                                  multi_options_answers: checkedValues,
                                  yes_or_no: false,
                                });
                                if (customError?.includes(qstn?.id)) {
                                  const updatedArray = customError.filter(
                                    (id) => id !== qstn?.id,
                                  );
                                  setCustomError(updatedArray);
                                }
                              }}
                              value={
                                watch(`question-${qstn?.id}`)
                                  ?.multi_options_answers
                              }
                              disabled={Boolean(isView)}
                            >
                              {qstn?.multi_options_answers?.map(
                                (item, i) => (
                                  <div
                                    key={`options-${i}`}
                                    className="feedback_radio"
                                  >
                                    <Checkbox
                                      className=""
                                      key={i}
                                      value={item.id}
                                    >
                                      {item.option}
                                    </Checkbox>
                                  </div>
                                ),
                              )}
                            </Checkbox.Group>
                            {customError?.includes(qstn?.id) && (
                              <p className="text-red-500 text-xs mt-1">
                                This field is required
                              </p>
                            )}
                          </div>
                        ) : qstn?.answer_type === 'BOOL' ? (
                          <div className="feedback_radio">
                            <Radio.Group
                              // {...register(`question-${qstn?.id}`, {
                              //   required: qstn?.is_mandatory
                              //     ? 'Please select Yes or No'
                              //     : false,
                              // })}
                              onChange={(e) =>
                                setValue(`question-${qstn?.id}`, {
                                  question: qstn?.id,
                                  answer: '',
                                  multi_options_answers: [],
                                  yes_or_no: e.target.value,
                                })
                              }
                              value={
                                watch(`question-${qstn?.id}`)?.yes_or_no
                              }
                              disabled={Boolean(isView)}
                            >
                              <Radio
                                className="feedback_radio"
                                key={'yes'}
                                value={true}
                              >
                                Yes
                              </Radio>
                              <Radio
                                className="feedback_radio"
                                key={'no'}
                                value={false}
                              >
                                No
                              </Radio>
                            </Radio.Group>
                            {customError?.includes(qstn?.id) && (
                              <p className="text-red-500 text-xs mt-1">
                                This field is required
                              </p>
                            )}
                          </div>
                        ) : qstn?.answer_type === 'EMOJI' ? (
                          <>
                            <div className="flex items-start justify-between w-2/3 mt-3 mx-2">
                              {emotions?.map((emo, index) => (
                                <Tooltip
                                  placement="bottom"
                                  title={emo?.label}
                                  overlayInnerStyle={{
                                    backgroundColor: '#1C4980',
                                    color: 'white',
                                    borderRadius: '8px',
                                    fontSize: '11px',
                                  }}
                                  overlayStyle={{
                                    backgroundColor: '#1C4980',
                                    borderRadius: '8px',
                                  }}
                                  color="#1C4980"
                                >
                                  <img
                                    key={index + '-' + qstn?.id}
                                    src={
                                      watch(`question-${qstn?.id}`)
                                        ?.emoji === emo?.value ||
                                      hoveredIndexForm ===
                                        index + '-' + qstn?.id
                                        ? emo.icon_active
                                        : emo.icon
                                    }
                                    alt={emo.label}
                                    className="cursor-pointer hover:scale-110 transition-transform duration-300 w-[30px] h-[30px]"
                                    onMouseEnter={() =>
                                      !Boolean(isView) &&
                                      setHoveredIndexForm(
                                        index + '-' + qstn?.id,
                                      )
                                    }
                                    onMouseLeave={() =>
                                      !Boolean(isView) &&
                                      setHoveredIndexForm(null)
                                    }
                                    onClick={() => {
                                      !Boolean(isView) &&
                                        setValue(`question-${qstn?.id}`, {
                                          question: qstn?.id,
                                          answer: '',
                                          multi_options_answers: [],
                                          yes_or_no: false,
                                          emoji: emo?.value,
                                        });
                                    }}
                                  />
                                </Tooltip>
                              ))}
                            </div>
                            {qstn?.is_mandatory &&
                              customError?.includes(qstn?.id) &&
                              !watch(`question-${qstn?.id}`)?.emoji && (
                                <p className="text-red-500 text-xs mt-1">
                                  This is required
                                </p>
                              )}
                          </>
                        ) : null}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="ms:w-1/2 w-full bg-[#EBF0F2] rounded-md p-11 flex justify-center">
                {/* <p className="text-[#494949] font-medium">Feedback</p> */}
                <div className="flex items-center justify-center flex-col mt-11">
                  <p className="text-[#000] text-2xl font-semibold mb-2">
                    Rate your experience
                  </p>
                  <p className="text-center w-4/5 text-[#3E3E3E] text-sm">
                    We love to hear from you! How’s your experience with
                    the yvi ai interview application
                  </p>
                  <div className="flex items-start justify-between w-2/3 mt-11">
                    {emotions?.map((emo, index) => (
                      <Tooltip
                        placement="bottom"
                        title={emo?.label}
                        overlayInnerStyle={{
                          backgroundColor: '#1C4980',
                          color: 'white',
                          borderRadius: '8px',
                          fontSize: '11px',
                        }}
                        overlayStyle={{
                          backgroundColor: '#1C4980',
                          borderRadius: '8px',
                        }}
                        color="#1C4980"
                      >
                        <img
                          key={index}
                          src={
                            watch('emotion') === emo.value ||
                            hoveredIndex === index
                              ? emo.icon_active
                              : emo.icon
                          }
                          alt={emo.label}
                          className="cursor-pointer hover:scale-110 transition-transform duration-300 w-[30px] h-[30px]"
                          onMouseEnter={() =>
                            !Boolean(isView) && setHoveredIndex(index)
                          }
                          onMouseLeave={() =>
                            !Boolean(isView) && setHoveredIndex(null)
                          }
                          onClick={() => {
                            !Boolean(isView) &&
                              setValue('emotion', emo.value);
                            setShowError(false);
                          }}
                        />
                      </Tooltip>
                    ))}
                  </div>
                  {showError && (
                    <p className="text-red-500 text-xs mt-1">
                      This is required
                    </p>
                  )}

                  <div className="w-full mt-16">
                    <Controller
                      name="comments"
                      control={control}
                      defaultValue=""
                      rules={{
                        required: 'This field is required', // Validation rule with error message
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <div>
                          <TextArea
                            {...field}
                            rows={4}
                            placeholder="Add a comment.."
                            className="placeholder:text-[#8F8F8F] placeholder:text-xs border border-[#AFD6D4] bg-[#FBFBFB] rounded-md"
                            disabled={Boolean(isView)}
                          />
                          {error && (
                            <p className="text-red-500 text-xs mt-1">
                              {error.message}
                            </p>
                          )}
                        </div>
                      )}
                    />
                  </div>
                  <div className="w-full mt-5">
                    {feedbackData?.candidate_name && (
                      <div className="flex items-center justify-between mb-2">
                        <p>Candidate</p>
                        <span>{feedbackData?.candidate_name}</span>
                      </div>
                    )}
                    {feedbackData?.interviewers && (
                      <div className="flex items-center justify-between mb-2">
                        <p>Interviewer</p>
                        <span>{feedbackData?.interviewers}</span>
                      </div>
                    )}
                    {feedbackData?.job_name && (
                      <div className="flex items-center justify-between mb-2">
                        <p>Job</p>
                        <span>{feedbackData?.job_name}</span>
                      </div>
                    )}
                    {feedbackData?.interview_level && (
                      <div className="flex items-center justify-between mb-2">
                        <p>Level</p>
                        <span>{feedbackData?.interview_level}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {!Boolean(isView) && (
              <div className="w-full ms:justify-end justify-between items-center gap-3 ms:w-4/6 flex mb-32 ms:mb-0 mt-0 ms:mt-5">
                {/* <button
                  type="submit"
                  className="bg-[#F7F7F7] px-6 py-2 flex items-center justify-center rounded-[86px] border border-[#000] font-medium text-[#000000]"
                >
                  Skip
                </button> */}
                <button
                  type="submit"
                  className="px-6 py-2 flex items-center justify-center  rounded-[86px] bg-[#11B2AB] text-[#FFF] font-medium"
                >
                  Submit
                </button>
              </div>
            )}
          </>
        )}
      </form>
    </>
  );
};

export default CandidateFeedBack;
